import { call, put } from 'redux-saga/effects';

import { MoveContentAction } from '~src/projects/actions/MoveContentAction';
import { MoveContentsAction, moveContentsSucceeded } from '~src/projects/actions/MoveContentsAction';
import { IResultWithDestinationProject } from '~src/projects/actions/MoveToProjectAction';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { getPersonalSpaceSucceded } from '../../../personalSpace/actions/PersonalSpaceActions';
import { callViaApiService } from '../../../personalSpace/restApi/PersonalSpace';
import { SessionManagementService } from '../../../sessionManagement/SessionManagementService';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';
import { removeFromContentSelection } from '../../actions/ContentExplorerSelectionActions';
import { requestSpaceContents } from '../../actions/RequestSpaceContentsActions';
import { IContentInfo } from '../../models/IContentInfo';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function openMoveContentDialog(content: IContentInfo[]): Promise<IResultWithDestinationProject> {
  return MoveContentAction.confirmMoveContent(content);
}

const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();

export function* handleMoveContentAction(action: MoveContentsAction) {
  try {
    if(sessionManagementService.isPersonalSpaceOnSiteEnabled()) {
      const result =  yield call(callViaApiService);
      yield put(getPersonalSpaceSucceded(result.personalSpace));
    }
    const mutableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.contentArray);
    yield call(openMoveContentDialog, mutableContentCopy);
    yield put(removeFromContentSelection(...action.contentArray));

    const didReload = yield call(reloadSpaceIfUpdatingCurrentSpace, action.contentArray);
    if (!didReload) {
      yield put(requestSpaceContents());
    }
    yield put(moveContentsSucceeded());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
